// extracted by mini-css-extract-plugin
export default {"LinkCopyWrapper":"LinkCopy_LinkCopyWrapper__pukBI","LinkCopy":"LinkCopy_LinkCopy__8WikT"};